import {
  DownlinkIcon,
  InternetShieldIcon,
  SitesIcon,
  SsdM2Icon,
} from "@ubnt/icons";
import React from "react";
import { IHeroSection } from "components/Hero/Hero.types";
import { ICondensedFeatureItem } from "pages/LayoutComponents/CondensedFeatureGrid/CondensedFeatureGrid.types";

import heroJpg from "./assets/videos/hero.jpg";
import heroMp4 from "./assets/videos/hero.mp4";
import cgCompact1Mp4 from "./assets/feature-tiles/cg-compact-1.mp4";
import cgCompact1Jpg from "./assets/feature-tiles/cg-compact-1.jpg";
import cgCompact2Mp4 from "./assets/feature-tiles/cg-compact-2.mp4";
import cgCompact2Jpg from "./assets/feature-tiles/cg-compact-2.jpg";
import cgCompact3Mp4 from "./assets/feature-tiles/cg-compact-3.mp4";
import cgCompact3Jpg from "./assets/feature-tiles/cg-compact-3.jpg";
import cgCompact4Mp4 from "./assets/feature-tiles/cg-compact-4.mp4";
import cgCompact4Jpg from "./assets/feature-tiles/cg-compact-4.jpg";

export const HERO_SECTIONS = [
  {
    id: 0,
    icon: null,
    label: "Discreet<br>and Compact",
    poster: heroJpg,
    src: heroMp4,
    playbackTimeInSeconds: 13,
  },
] satisfies IHeroSection[];

export const FEATURE_COMPLETE_TILES = [
  {
    id: "site-manager-ready",
    assets: {
      src: cgCompact1Mp4,
      poster: cgCompact1Jpg,
      icon: <SitesIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cloudGateways.compact.featureTiles.siteManager.title",
    description: "cloudGateways.compact.featureTiles.siteManager.description",
  },
  {
    id: "sfp-10gbe-wan",
    assets: {
      src: cgCompact2Mp4,
      poster: cgCompact2Jpg,
      icon: <DownlinkIcon size={50} color="#3B3F45" />,
    },
    variant: "light",
    title: "cloudGateways.compact.featureTiles.sfp.title",
    description: "cloudGateways.compact.featureTiles.sfp.description",
  },
  {
    id: "m2-nvme-ssd-storage",
    assets: {
      src: cgCompact3Mp4,
      poster: cgCompact3Jpg,
      icon: <SsdM2Icon size={50} color="#3B3F45" />,
    },
    variant: "light",
    title: "cloudGateways.compact.featureTiles.ssdStorage.title",
    description: "cloudGateways.compact.featureTiles.ssdStorage.description",
    isSelectedModelsOnly: true,
  },
  {
    id: "site-magic",
    assets: {
      src: cgCompact4Mp4,
      poster: cgCompact4Jpg,
      icon: <InternetShieldIcon size={50} color="#3B3F45" />,
    },
    variant: "dark",
    title: "cloudGateways.compact.featureTiles.siteMagic.title",
    description: "cloudGateways.compact.featureTiles.siteMagic.description",
  },
] satisfies Array<ICondensedFeatureItem>;
